import * as React from "react";
import Popover from "@mui/material/Popover";
import MxTypography from "@rf-l1/MxTypography";
import { Grid } from "@mui/material";

interface MxPopoverProps {
  children?: React.ReactNode;
  message?: string;
}
export default function MxPopover(props: MxPopoverProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      {React.cloneElement(props.children as React.ReactElement, {
        onClick: handleClick,
        ["aria-describedby"]: id,
        variant: "contained"
      })}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
      >
        <Grid container item xs={12} p={1}>
          <MxTypography
            variant="caption" 
            color="gray"
            fontWeight={400}
            textAlign={"left"}
          >
            {props.message}
          </MxTypography>
        </Grid>
      </Popover>
    </div>
  );
}
